<div *ngIf="pageInfo?.title !== 'Analytical' && pageInfo?.title !== 'eCommerce'">
  <div class="bg-light-primary rounded p-y-30 p-x-24 m-b-30 overflow-hidden">
    <div class="row">
      <div class="col-sm-8">
        <h4 class="page-title m-0 f-s-20 f-w-600 m-b-16">
          {{ pageInfo?.title | translate }}
        </h4>
        <h4 *ngIf="otherTitle != ''">{{ otherTitle | translate }}</h4>
        <div class="d-flex align-items-center overflow-hidden">
          <ul class="breadcrumb">
            <li
              class="breadcrumb-item"
              *ngFor="let url of pageInfo?.urls; let last = last; let i = index"
              [ngClass]="{ active: last }"
            >
              <ng-container *ngIf="!last; else lastCrumb">
                <ng-container *ngIf="url.url; else plainCrumb">
                  <a [routerLink]="url.url">{{ url.title | translate }}</a>
                </ng-container>
                <ng-template #plainCrumb>
                  <span>{{ url.title | translate }}</span>
                </ng-template>
                <span class="breadcrumb-sep"> / </span>
              </ng-container>
              <ng-template #lastCrumb>
                <span class="ml-2">{{ url.title | translate }}</span>
              </ng-template>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-sm-4 text-right position-relative">
        <div class="breadcrumb-icon">
          <img
            src="/assets/images/breadcrumb/bola_infos.png"
            width="165"
            alt="breadcrumb"
          />
        </div>
      </div>
    </div>
  </div>
</div>
